import { render } from "./SettingsNon2.vue?vue&type=template&id=84d8a31e&scoped=true&ts=true"
import script from "./SettingsNon2.vue?vue&type=script&lang=ts"
export * from "./SettingsNon2.vue?vue&type=script&lang=ts"

import "./SettingsNon2.vue?vue&type=style&index=0&id=84d8a31e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d8a31e"]])

export default __exports__